module.exports = __webpack_public_path__ + "static/media/logo2.651e00ee.png";